import * as types from "./types";

const initialState = {
  // Dashboard
  dashboard: {
    loading: false,
    error: null,
    data: null,
  },
  // Profile
  profile: {
    loading: false,
    error: null,
    data: null,
  },
  // Tasks List
  tasks: {
    loading: false,
    error: null,
    data: [],
  },
  // Current Task Detail
  currentTask: {
    loading: false,
    error: null,
    data: null,
  },
  // Action states
  startingTask: false,
  completingTask: false,
  uploadingPhoto: false,
  actionError: null,
};

const providerPortalReducer = (state = initialState, action) => {
  switch (action.type) {
    // Dashboard
    case types.FETCH_PROVIDER_DASHBOARD_INIT:
      return {
        ...state,
        dashboard: { ...state.dashboard, loading: true, error: null },
      };
    case types.FETCH_PROVIDER_DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboard: { loading: false, error: null, data: action.payload },
      };
    case types.FETCH_PROVIDER_DASHBOARD_FAILURE:
      return {
        ...state,
        dashboard: { loading: false, error: action.payload, data: null },
      };

    // Profile
    case types.FETCH_PROVIDER_PROFILE_INIT:
      return {
        ...state,
        profile: { ...state.profile, loading: true, error: null },
      };
    case types.FETCH_PROVIDER_PROFILE_SUCCESS:
      return {
        ...state,
        profile: { loading: false, error: null, data: action.payload },
      };
    case types.FETCH_PROVIDER_PROFILE_FAILURE:
      return {
        ...state,
        profile: { loading: false, error: action.payload, data: null },
      };

    // Tasks List
    case types.FETCH_PROVIDER_TASKS_INIT:
      return {
        ...state,
        tasks: { ...state.tasks, loading: true, error: null },
      };
    case types.FETCH_PROVIDER_TASKS_SUCCESS:
      return {
        ...state,
        tasks: { loading: false, error: null, data: action.payload },
      };
    case types.FETCH_PROVIDER_TASKS_FAILURE:
      return {
        ...state,
        tasks: { loading: false, error: action.payload, data: [] },
      };

    // Task Detail
    case types.FETCH_PROVIDER_TASK_DETAIL_INIT:
      return {
        ...state,
        currentTask: { ...state.currentTask, loading: true, error: null },
      };
    case types.FETCH_PROVIDER_TASK_DETAIL_SUCCESS:
      return {
        ...state,
        currentTask: { loading: false, error: null, data: action.payload },
      };
    case types.FETCH_PROVIDER_TASK_DETAIL_FAILURE:
      return {
        ...state,
        currentTask: { loading: false, error: action.payload, data: null },
      };

    // Start Task
    case types.START_PROVIDER_TASK_INIT:
      return { ...state, startingTask: true, actionError: null };
    case types.START_PROVIDER_TASK_SUCCESS:
      return {
        ...state,
        startingTask: false,
        currentTask: { ...state.currentTask, data: action.payload },
      };
    case types.START_PROVIDER_TASK_FAILURE:
      return { ...state, startingTask: false, actionError: action.payload };

    // Complete Task
    case types.COMPLETE_PROVIDER_TASK_INIT:
      return { ...state, completingTask: true, actionError: null };
    case types.COMPLETE_PROVIDER_TASK_SUCCESS:
      return {
        ...state,
        completingTask: false,
        currentTask: { ...state.currentTask, data: action.payload },
      };
    case types.COMPLETE_PROVIDER_TASK_FAILURE:
      return { ...state, completingTask: false, actionError: action.payload };

    // Upload Photo
    case types.UPLOAD_TASK_PHOTO_INIT:
      return { ...state, uploadingPhoto: true, actionError: null };
    case types.UPLOAD_TASK_PHOTO_SUCCESS:
      return {
        ...state,
        uploadingPhoto: false,
        currentTask: { ...state.currentTask, data: action.payload },
      };
    case types.UPLOAD_TASK_PHOTO_FAILURE:
      return { ...state, uploadingPhoto: false, actionError: action.payload };

    // Clear states
    case types.CLEAR_PROVIDER_TASK_DETAIL:
      return {
        ...state,
        currentTask: { loading: false, error: null, data: null },
      };
    case types.CLEAR_PROVIDER_ERROR:
      return { ...state, actionError: null };

    default:
      return state;
  }
};

export default providerPortalReducer;
